












import { defineComponent, ref } from '@vue/composition-api';
import { Area } from '@/store/types';
import AreaEditForm from './AreaEditForm.vue';

export default defineComponent({
	components: { AreaEditForm },
	props: {
		area: {
			type: Object as () => Area,
			required: true,
		},
	},
	setup() {
		const showEditDialog = ref<boolean>(false);

		return {
			showEditDialog,
		};
	},
});
